import { render, staticRenderFns } from "./BancosComponent.vue?vue&type=template&id=984531fa&"
import script from "./BancosComponent.vue?vue&type=script&lang=js&"
export * from "./BancosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports